import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';

import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { Helper } from '../../common/helpers/Helper';
import { AppStyles } from '../../styles/AppTheme';
import { AppHelper } from '../../helpers/AppHelper';


export class EventsListPartner extends BaseEntityPage {

  constructor(props) {
    super(props, { pageForOrgType: 'PARTNER' });
    this.pageKey = 'Events';
    this.pageTitle = 'Events';
    this.noAdd = true;
    this.orgId = this.props.match.params.orgId;
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ];
    this.tableHeadersMap = {
      Index: (current) => { return <span className={css(Styles.value)}>{current.__index + 1}</span> },
      EventType: (current) => AppHelper.getAlertTitle(current.eventType),
      Devices: (current) => {
        const devices = Array.isArray(current.devices) ? current.devices : []
        return <span>
          {current.eventType === 'CONNECTIVITYALERT' ? 'Offline Device(s): ' : 'Device(s): '} {devices.length}
        </span>
      },
      // Emails: (current) => Array.isArray(current.emails) ? current.emails.join(', ') : (current.emails || '-'),
      CreatedTs: (current) => {
        return <sapn>Event Time: {Helper.formatDateWithTimezoneSuffix({ utcTimestamp: current.createdTs })}</sapn>
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.noAdd = true
    this.noTableHead = true
    this.emptyText = 'No events found';
    this.toFetch = [
      { method: 'GET', paths: ['miscs', 'events'], queryParams: { orgId: this.orgId } },
    ];
  }

  onFetchSuccess(results) {
    const response = results[0] || {}
    const items = (response.items || []).map((item, index) => ({
      ...item,
      id: item.id || item.eventId || `${item.eventType || 'event'}-${index}`,
    }))
    this.setState({
      items,
    });
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  drillDownButton(current) {
    const eventId = current.id || current.eventId
    if (!eventId) return null
    return (
      <Link to={`/admin/partners/${this.orgId}/events/${encodeURIComponent(eventId)}`} key={`${eventId}-details`}>
        <Tooltip title='Details' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>playlist_play</i>
          </span>
        </Tooltip>
      </Link>
    )
  }

  onActions(current) {
    const actions = []
    const detailAction = this.drillDownButton(current)
    if (detailAction) actions.push(detailAction)
    return actions
  }
}

const Styles = StyleSheet.create({
  value: {
    fontSize: 12,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
});



// WEBPACK FOOTER //
// ./src/screens/admin/EventsListPartner.js